module.exports = __webpack_public_path__ + "img/banner-sm-02.78decbc7.jpg";